import loadView from "@/utils/load-view";

const routes = [
    // Legacy routes
    {
        path: "/login",
        redirect: "/auth/login",
    },
    {
        path: "/logout",
        redirect: "/auth/logout",
    },
    {
        path: "/loginOverride/:token",
        redirect: "/auth/login/impersonate/:token",
    },
    {
        path: "/login/:userId/:token",
        redirect: "/auth/login/:userId/:token",
    },
    {
        path: "/register/:teamId/:inviteToken",
        redirect: "/auth/invite/:teamId/:inviteToken",
    },
    {
        path: "/password/request",
        redirect: "/auth/password-reset-request",
    },
    {
        path: "/password/reset/:userId/:token",
        redirect: "/auth/password-reset/:userId/:token",
    },
    // Current routes
    {
        path: "/auth/login",
        name: "Login",
        component: loadView("AuthLogin"),
        meta: {
            authRequired: false,
            guestsOnly: true,
            resolvers: [],
        },
    },
    {
        path: "/auth/logout",
        name: "Logout",
        component: loadView("AuthLogin"),
        meta: {
            authRequired: false,
            resolvers: [
                () => ({
                    type: "auth/logout",
                    payload: {},
                }),
            ],
        },
    },
    {
        path: "/auth/login/impersonate/:token",
        name: "LoginThroughImpersonationToken",
        component: loadView("AuthTokenLogin"),
        props: true,
        meta: {
            authRequired: false,
            guestsOnly: true,
            resolvers: [
                to => ({
                    type: "auth/updateSession",
                    payload: {
                        token: to.params.token,
                    },
                }),
            ],
        },
    },
    {
        path: "/auth/login/:userId/:token",
        name: "LoginWithToken",
        component: loadView("AuthTokenLogin"),
        props: true,
        meta: {
            authRequired: false,
            guestsOnly: true,
            resolvers: [],
        },
    },
    {
        path: "/auth/invite/:teamId/:inviteToken",
        name: "SignUpWithInvite",
        component: loadView("AuthInvite"),
        props: true,
        meta: {
            authRequired: false,
            guestsOnly: true,
            resolvers: [
                to => ({
                    type: "auth/getInvite",
                    payload: {
                        teamId: to.params.teamId,
                        inviteToken: to.params.inviteToken,
                    },
                }),
            ],
        },
    },
    {
        path: "/auth/password-reset-request",
        name: "PasswordResetRequest",
        component: loadView("AuthPasswordResetRequest"),
        meta: {
            authRequired: false,
            guestsOnly: true,
            resolvers: [],
        },
    },
    {
        path: "/auth/password-reset/:userId/:token",
        name: "PasswordReset",
        component: loadView("AuthPasswordReset"),
        props: true,
        meta: {
            authRequired: false,
            guestsOnly: true,
            resolvers: [],
        },
    },
];

export default routes;
